(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["orbitopia-home-premium"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ot-home-carousel')) {
  customElements.define('ot-home-carousel', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.controller) return;
      this.track = this.querySelector('[data-ot-home-track]');
      this.previous = this.querySelector('[data-ot-home-prev]');
      this.next = this.querySelector('[data-ot-home-next]');
      if (!this.track || !this.previous || !this.next || !this.track.firstElementChild) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.queueUpdate(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          this.move(rtl ? -direction : direction);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          const end = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : end * (rtl ? -1 : 1), behavior: this.behavior() });
        }
      }, options);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.queueUpdate(), options);
      }
      this.setAttribute('data-ready', '');
      this.update();
    }

    behavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    }

    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: step * direction * (style.direction === 'rtl' ? -1 : 1), behavior: this.behavior() });
    }

    queueUpdate() {
      if (this.updateFrame) return;
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = 0;
        this.update();
      });
    }

    update() {
      if (!this.track || !this.isConnected) return;
      const end = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const position = Math.max(0, Math.min(end, this.track.scrollLeft * (rtl ? -1 : 1)));
      this.previous.disabled = position <= 1;
      this.next.disabled = end <= 1 || position >= end - 1;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      cancelAnimationFrame(this.updateFrame);
      if (this.controller) this.controller.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.controller = null;
      this.resizeObserver = null;
      this.updateFrame = 0;
      this.removeAttribute('data-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
